import * as preact from "preact";

import * as appStorePurchases from "appStorePurchases";
import type { PreactPageProps } from "pages/PreactPage";
import * as planFeatures from "shared/planFeatures";
import stores from "stores/stores";

type Props = {
  /** Opens the app's paywall straight away */
  openPaywall?: boolean;
};

/**
 * Readlang Premium in the iOS app, in place of the website's checkout, which
 * Apple doesn't allow there: what each plan includes, with the app's paywall
 * (the App Store's prices, in the user's currency) a tap away.
 */
export class AppPremium extends preact.Component<Props> {
  componentDidMount() {
    if (this.props.openPaywall && !stores.user.hasPremiumAccess.value) {
      void this.showPaywall();
    }
  }

  private showPaywall = () => appStorePurchases.showPaywall({});

  render() {
    if (stores.user.hasPremiumAccess.value) {
      // Changing plan is Apple's (Manage Subscription) or the website's job
      return (
        <div class="appPremiumPage">
          <h2>Readlang Premium</h2>
          <p>
            You have Readlang Premium. <a href="/account">See your account</a>.
          </p>
        </div>
      );
    }
    return (
      <div class="appPremiumPage">
        <h2>Readlang Premium</h2>
        {planFeatures.plans.map((plan) => (
          <div class="appPremiumPlan" key={plan.name}>
            <h3>{plan.name}</h3>
            <ul>
              {plan.features.map((feature) => (
                <li key={feature}>{feature}</li>
              ))}
            </ul>
          </div>
        ))}
        <button class="appPremiumBuy" onClick={this.showPaywall}>
          See plans and prices
        </button>
      </div>
    );
  }
}

export default class AppPremiumPageView extends preact.Component<PreactPageProps> {
  render() {
    return <AppPremium openPaywall={true} />;
  }
}
